import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { HttpService } from '../../services/http.service';
import { ConstantsService } from '../../constants/constants.service';
import { Router, RouterLink } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [FormsModule, CommonModule,RouterLink],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent implements OnInit {
  formSubmitted: boolean = false;
  formSubmitLoader: boolean = false;
  userId: string = '';
  user: any = {
    email: '',
    otp: '',
    password: ''
  };
  showMainTab = true;
  tab1 = true;
  otp: string[] = ['', '', '', ''];
  showTabEmail: boolean = false;
  showError: boolean = false;
    showPassword: boolean = false;
  showPrivacyPolicy: boolean = false;
  passwordPattern: RegExp = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()\-_\+=\|[\]{};:\/?\.])(?=\S+$).{8,}$/;

  // For OTP resend functionality
  timeLeft: number = 120; 
  intervalId: any; 
  canResend: boolean = false;
  otpStartTime: number = 0;
  readonly OTP_DURATION = 120;

  constructor(
    private httpService: HttpService,
    public constants: ConstantsService,
    private router: Router,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    if (sessionStorage.getItem('currentUser')) {
      this.router.navigate(['/dashboard']);
    }
    this.showTabEmail = true;
    document.addEventListener('visibilitychange', () => {
    if (!document.hidden && this.otpStartTime > 0) {
      const elapsed = Math.floor((Date.now() - this.otpStartTime) / 1000);
      this.timeLeft = Math.max(0, this.OTP_DURATION - elapsed);

      if (this.timeLeft <= 0) {
        this.canResend = true;
        clearInterval(this.intervalId);
      }
      this.cdr.detectChanges();
    }
  });
  }
  clearOtpInputs() {
  this.otp = ['', '', '', ''];
  this.cdr.detectChanges();
  // Clear the actual input elements
  setTimeout(() => {
  for (let i = 0; i < 4; i++) {
    const fieldName = `otp${i}`;
    const inputElement = document.getElementsByName(fieldName)[0] as HTMLInputElement;
    if (inputElement) {
      inputElement.classList.remove('ng-touched');
      inputElement.classList.add('ng-untouched');
    }
  }
}, 0);

}

  forgotPassword(form: NgForm) {
    this.formSubmitted = true;

    if (!form.valid) {
      return;
    }

    if (this.userId) {
      this.resetPassword();
    } else {
      this.formSubmitLoader = true;
      this.httpService.postRequest(this.constants.SERVER_URLS['FORGOT_PASSWORD'], { email: this.user.email }).subscribe((res: any) => {
        this.formSubmitLoader = false;
        if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
          this.toastr.success(res.message);
          this.tab1 = false;
          this.userId = res.result;
          this.clearOtpInputs();
          this.startTimer();
        } else {
          this.toastr.error(res.message);
        }
      }, () => {
        this.formSubmitLoader = false;
      });
    }
  }

  onOtpInput(event: any, index: number) {
  const input = event.target;
  let value = input.value;

  // Remove any non-digit characters
  value = value.replace(/\D/g, '');
  
  // Take only the last character if multiple characters are entered
  if (value.length > 1) {
    value = value.slice(-1);
  }

  // Update the input value and array
  input.value = value;
  this.otp[index] = value;

  // Move to next input if value is entered
  if (index < 3 && value) {
    const nextInput = document.querySelector(`.otp-input-${index + 1}`) as HTMLInputElement;
    if (nextInput) {
      nextInput.focus();
    }
  }
}

  onOtpKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;

    if (event.key === 'Backspace') {
      // If current input is empty, move to previous input
      if (!input.value && index > 0) {
        const prevInput = document.querySelector(`.otp-input-${index - 1}`) as HTMLInputElement;
        if (prevInput) {
          prevInput.focus();
        }
      } else {
        // Clear current input if not already empty
        this.otp[index] = '';
      }
    }
  }

  onOtpInputMobile(event: any, index: number) {
  const input = event.target;
  let value = input.value;

  // Remove any non-digit characters
  value = value.replace(/\D/g, '');
  
  // Take only the last character if multiple characters are entered
  if (value.length > 1) {
    value = value.slice(-1);
  }

  // Update the input value and array
  input.value = value;
  this.otp[index] = value;

  // Move to next input if value is entered
  if (index < 3 && value) {
    const nextInput = document.querySelector(`.motp-input-${index + 1}`) as HTMLInputElement;
    if (nextInput) {
      nextInput.focus();
    }
  }
}

  onOtpKeyDownMobile(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
  
    if (event.key === 'Backspace') {
      // If current input is empty, move to previous input
      if (!input.value && index > 0) {
        const prevInput = document.querySelector(`.motp-input-${index - 1}`) as HTMLInputElement;
        if (prevInput) {
          prevInput.focus();
        }
      } else {
        // Clear current input if not already empty
        this.otp[index] = '';
      }
    }
  }
  resetPassword() {
    if (this.otp.join('').length != 4) {
      this.showError = true;
    }
    if (this.otp.join('').length === 4) {
      this.user.otp = this.otp.join('');
    }
    this.formSubmitLoader = true;
    const data = {
      userId: this.userId,
      email: this.user.email,
      otp: this.user.otp,
      password: this.user.password
    };

    this.httpService.postRequest(this.constants.SERVER_URLS['RESET_PASSWORD'], data).subscribe((res: any) => {
      this.formSubmitLoader = false;
      if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
        this.toastr.success(res.message);
        this.router.navigate(['/login']);
      } else {
        this.toastr.error(res.message);
      }
    }, () => {
      this.formSubmitLoader = false;
    });
  }

   openPrivacyModal(){
    this.showPrivacyPolicy = true;
  }

  closePrivacyModal(){
    this.showPrivacyPolicy = false;
  }

  // For OTP resend functionality
   resendOtp() {
  const data = {email: this.user.email};
  this.formSubmitLoader = true;
  this.httpService.postRequest(this.constants.SERVER_URLS['RESEND_USER_OTP'],data).subscribe(
    (res: any) => {
      this.formSubmitLoader = false;
      if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
        this.toastr.success(res.message);
        // Clear OTP inputs when resending
        this.clearOtpInputs();
        this.startTimer();
      } else {
        this.toastr.error(res.message,);
      }
    },
    (err) => {
      this.formSubmitLoader = false;
      this.toastr.error('Failed to resend OTP',  );
    }
  );
}

  startTimer() {
  if (this.intervalId) {
    clearInterval(this.intervalId);
  }

  this.otpStartTime = Date.now();
  this.canResend = false;

  this.intervalId = setInterval(() => {
    const elapsed = Math.floor((Date.now() - this.otpStartTime) / 1000);
    this.timeLeft = Math.max(0, this.OTP_DURATION - elapsed);

    if (this.timeLeft <= 0) {
      clearInterval(this.intervalId);
      this.canResend = true;
      this.cdr.detectChanges();
    }
  }, 1000);
}
  formatTimer(): string {
    const minutes = Math.floor(this.timeLeft / 60);
    const seconds = this.timeLeft % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}s`;
  }
  
  isPasswordValid(password: string): boolean {
    return this.passwordPattern.test(password);
  }
}
